export default "__VITE_ASSET__AX1ZMEi3__"